import {
  HotlineBarFixedNew as HotlineBarFixedUI,
  useHotlineBarFixedNew,
} from '@travel-frontend/ui-components';
import {forwardRef, memo} from 'react';

import {LayerPortal} from '@/components/LayerPortal';
import {ONE_DAY_MS} from '@/consts';
import {useLocalSplit} from '@/modules/common/hooks';
import {useHeaderConfig} from '@/modules/common/hooks/useHeaderConfig';

const Component = forwardRef<HTMLDivElement>(function HotlineBarFixed(_, ref) {
  const headerConfig = useHeaderConfig();
  const splitEnabled =
    useLocalSplit('FFP_3680_hotline_sticky_bar').treatment === 'on';
  const {visible, dismiss: handleDismiss} = useHotlineBarFixedNew({
    offset: 1,
    timeOff: ONE_DAY_MS,
  });

  // sanity check (just in case)
  // better to render nothing than to crash
  if (!headerConfig?.hotline) {
    return null;
  }

  return (
    <LayerPortal>
      <HotlineBarFixedUI
        ref={ref}
        // has to stay mounted because "useResizeObserver()" (see call sites),
        // somehow doesn't update if the component were to be removed entirely ("return null").
        // don't know why
        visible={splitEnabled && visible}
        config={headerConfig.hotline}
        // @FIXME
        // We need a way to control children priorities inside <LayerPortal />.
        // Basically if multiple layers inside <LayerPortal /> have the same z-index self assigned,
        // then the order in which they are inserted matters to determine which one to show on top...
        // Or, alternatively, better define the stacking levels to begin with.
        // @ts-expect-error ...
        style={{zIndex: 3}}
        onClose={handleDismiss}
      />
    </LayerPortal>
  );
});

export const HotlineBarFixed = memo(Component);
